import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

export const path = '/my-notification/list';

const PageMyNotificationList: React.FC = (props) => {
  const MyNotificationList = Loadable.Map({
    loader: {
      page: () => import('./page'),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <MyNotificationList {...props} />;
};

export default PageMyNotificationList;
